// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604131251/js/" + chunkId + "." + {"44":"9bc3caac","225":"ce2366e7","481":"60455d9e","486":"04794542","770":"3a62b6fc"}[chunkId] + ".0.5106832009079121.chunk.js";
};